export default (...names: string[]) => names.join('/');
